module.exports = __webpack_public_path__ + "img/qr.d3e84f41.jpg";